export default "__VITE_ASSET__h0vry86H__"